import { mergeClasses } from '@fluentui/react-components';
import React, { useMemo } from 'react';
import { ViewMode } from './Constants';
import { FlexPanel } from './FlexPanel';
import { KeyNavDir } from './FlexPanel.types';
import { useFlyoutStyles } from './Flyout.styles';
import { SuggestionsAndSearchRenderer } from './FlyoutSuggestionsSection';
import { LaunchTile } from './LaunchTile';
/**
 * Container to display Search Results in the Flyout
 */
export var FlyoutSearchResults = function (_a) {
    var userSearchQuery = _a.userSearchQuery, installedTiles = _a.installedTiles, launchTileBehaviorRef = _a.launchTileBehavior, linkedEntity = _a.linkedEntity, onResultClick = _a.onResultClick, onPinStateChange = _a.onPinStateChange, showContextMenu = _a.showContextMenu, searchResultsSectionTitle = _a.searchResultsSectionTitle, installedAppsSectionAriaLabel = _a.installedAppsSectionAriaLabel, suggestedAppsSectionAriaLabel = _a.suggestedAppsSectionAriaLabel, installedAppsAnnouncementMessage = _a.installedAppsAnnouncementMessage, suggestedAppsAnnouncementMessage = _a.suggestedAppsAnnouncementMessage, installedAndSuggestedAppsAnnouncementMessage = _a.installedAndSuggestedAppsAnnouncementMessage;
    var styles = useFlyoutStyles();
    var installedSearchResults = useMemo(function () {
        return installedTiles === null || installedTiles === void 0 ? void 0 : installedTiles.filter(function (appTile) {
            return (!appTile.node.hideFromSearch &&
                appTile.node.name
                    .toLowerCase()
                    .includes(userSearchQuery.toLowerCase()));
        });
    }, [userSearchQuery, installedTiles]);
    var buildLaunchTilesFromTileData = React.useCallback(function (tileData) {
        return tileData === null || tileData === void 0 ? void 0 : tileData.map(function (app, index) {
            var pinStateChangedCallback = function (pinnedState) {
                if (onPinStateChange) {
                    onPinStateChange(app.node.id, pinnedState);
                }
            };
            return (React.createElement(LaunchTile, { viewMode: ViewMode.Flyout, index: index, key: app.node.id, m365App: app.node, onClicked: onResultClick, launchTileBehavior: launchTileBehaviorRef, onPinStateChange: pinStateChangedCallback, linkedEntity: linkedEntity, onContextMenu: showContextMenu, isListItem: true }));
        });
    }, [
        launchTileBehaviorRef,
        linkedEntity,
        onPinStateChange,
        onResultClick,
        showContextMenu,
    ]);
    var installedSearchResultTiles = useMemo(function () {
        var _a;
        var acquiredAppTiles = (_a = buildLaunchTilesFromTileData(installedSearchResults)) !== null && _a !== void 0 ? _a : [];
        return acquiredAppTiles.length > 0 ? (React.createElement(FlexPanel, { horizontal: true, wrap: true, className: styles.installedAppsWrapper, keyNavigationDirection: KeyNavDir.gridLinear, role: "listbox", "aria-label": installedAppsSectionAriaLabel }, acquiredAppTiles)) : undefined;
    }, [
        buildLaunchTilesFromTileData,
        installedAppsSectionAriaLabel,
        installedSearchResults,
        styles.installedAppsWrapper,
    ]);
    var tileContainer = useMemo(function () {
        var _a;
        var tilesContainerClass = mergeClasses(styles.tilesContainer, styles.tilesContainerSearchEnabled);
        return (React.createElement(FlexPanel, { className: tilesContainerClass },
            installedSearchResultTiles,
            React.createElement(SuggestionsAndSearchRenderer, { installedAppCount: (_a = installedSearchResults === null || installedSearchResults === void 0 ? void 0 : installedSearchResults.length) !== null && _a !== void 0 ? _a : 0, suggestedAppsSectionTitle: searchResultsSectionTitle, suggestedAppsSectionAriaLabel: suggestedAppsSectionAriaLabel, installedAppsAnnouncementMessage: installedAppsAnnouncementMessage, suggestedAppsAnnouncementMessage: suggestedAppsAnnouncementMessage, installedAndSuggestedAnnouncementMessage: installedAndSuggestedAppsAnnouncementMessage })));
    }, [
        styles.tilesContainer,
        styles.tilesContainerSearchEnabled,
        installedSearchResultTiles,
        installedSearchResults,
        searchResultsSectionTitle,
        suggestedAppsSectionAriaLabel,
        installedAppsAnnouncementMessage,
        suggestedAppsAnnouncementMessage,
        installedAndSuggestedAppsAnnouncementMessage,
    ]);
    return React.createElement(React.Fragment, null, tileContainer);
};
export default FlyoutSearchResults;
//# sourceMappingURL=FlyoutSearchResults.js.map